import {EActionNames} from "src/store/enums";
import {IAppState, TActions} from "src/store/models";
import {addBoxReducer} from "src/store/reducers/adding/addBoxReducer";
import {addFruitReducer} from "src/store/reducers/adding/addFruitReducer";
import {addShelfReducer} from "src/store/reducers/adding/addShelfReducer";
import {changeContainerReducer} from "src/store/reducers/changing/changeContainerReducer";
import {sortElementsReducer} from "src/store/reducers/sorting/sortElementsReducer";

export function rootReducer(state: IAppState, action: TActions) {
    switch (action.type) {
        case EActionNames.ADD_SHELF:
            return addShelfReducer(state, action);
        case EActionNames.ADD_BOX:
            return addBoxReducer(state, action);
        case EActionNames.ADD_FRUIT:
            return addFruitReducer(state, action);
        case EActionNames.CHANGE_CONTAINER:
            return changeContainerReducer(state, action);
        case EActionNames.CHANGE_TREE_MAPPED:
            return {...state, mappedTrees: state.mappedTrees + 1};
        case EActionNames.CHANGE_DRAGGING_ELEMENT:
            const {id, type} = action.payload;
            return {...state, draggingElement: {id, type}};
        case EActionNames.SORT_ELEMENTS:
            return sortElementsReducer(state, action);
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/store/reducer.ts